import { EventTypes, IReducerPayload, INavigationReducer, IActiveModuleMasterMenu } from '../dataModels';
import { IReduxAction } from '@core-web/redux';

const initialState: INavigationReducer = {
  activePage: 'Home',
  activeMasterMenu: null,
  activeModule: null,
  modules: [],
  drawerMenus: [],
};

export const Reducer = (
  state: INavigationReducer = initialState,
  { type, payload }: IReduxAction<EventTypes, IReducerPayload>
) => {
  switch (type) {
    case EventTypes.SET_ACTIVE_PAGE: {
      return { ...state, ...payload };
    }
    case EventTypes.GET_MODULES: {
      return { ...state, modules: payload };
    }
    case EventTypes.GET_MENUS: {
      return { ...state, drawerMenus: payload };
    }
    case EventTypes.SET_ACTIVE_MASTER_MENU: {
      return { ...state, activeMasterMenu: payload };
    }
    case EventTypes.SET_ACTIVE_MODULE: {
      return { ...state, activeModule: payload };
    }
    case EventTypes.SET_ACTIVE_MODULE_MASTER_MENU: {
      const { module, masterMenu } = payload as IActiveModuleMasterMenu;
      return { ...state, activeModule: module, activeMasterMenu: masterMenu };
    }
    default: {
      return state;
    }
  }
};
